(() => {
  const SCHEMA_VERSION = '1';
  const TRACKING_VERSION = '20260806.1';
  const MAX_VALUE_LENGTH = 120;

  function cleanValue(value) {
    return String(value ?? '')
      .trim()
      .replace(/[\r\n\t]+/g, ' ')
      .slice(0, MAX_VALUE_LENGTH);
  }

  function propertiesFromCard(card, overrides = {}) {
    const dataset = card?.dataset || {};
    const source = cleanValue(overrides.source ?? dataset.nhUpsellSource);
    if (!source) return {};

    const values = {
      _nh_upsell_schema: SCHEMA_VERSION,
      _nh_upsell_source: source,
      _nh_upsell_position: cleanValue(overrides.position ?? dataset.nhUpsellPosition ?? dataset.nhUpsellRank),
      _nh_upsell_parent_product: cleanValue(
        overrides.parentProduct ?? dataset.nhUpsellParentProductId ?? dataset.nhUpsellSourceProductId,
      ),
      _nh_upsell_parent_variant: cleanValue(
        overrides.parentVariant ?? dataset.nhUpsellParentVariantId ?? dataset.nhUpsellSourceVariantId,
      ),
      _nh_upsell_offer: cleanValue(overrides.offer ?? dataset.nhUpsellOffer),
      _nh_upsell_version: cleanValue(overrides.version ?? dataset.nhUpsellVersion ?? TRACKING_VERSION),
      _nh_upsell_mechanism: cleanValue(overrides.mechanism ?? dataset.nhUpsellMechanism),
    };

    return Object.fromEntries(Object.entries(values).filter(([, value]) => value !== ''));
  }

  function appendToFormData(formData, properties) {
    if (!formData?.append) return formData;

    Object.entries(properties || {}).forEach(([key, value]) => {
      if (key.startsWith('_nh_') && value !== '') formData.append(`properties[${key}]`, value);
    });

    return formData;
  }

  const api = Object.freeze({
    schemaVersion: SCHEMA_VERSION,
    trackingVersion: TRACKING_VERSION,
    propertiesFromCard,
    appendToFormData,
  });

  if (typeof window !== 'undefined') window.NHUpsellAttribution = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})();
